import React, { useEffect, useState, useRef } from "react";
import { Card, Form, Select, Input, Button, Space, Divider, Descriptions, Tag, Typography, Timeline, Skeleton, Row, Col } from "antd";
import { CheckCircleOutlined, HistoryOutlined } from "@ant-design/icons";
import { connect } from "react-redux";
import { getlog } from "../../../../actions/userlogAction";
import dateFormat from "dateformat";
import moment from "moment";


const { Option } = Select;
const { Text } = Typography;

const OrderStatusTab = ({ selectedOrder, onUpdate, loading, getlog }) => {
  const [statusForm] = Form.useForm();
  const [submitting, setSubmitting] = useState(false);
  const [logs, setLogs] = useState([]);
  const [logsLoading, setLogsLoading] = useState(false);
  console.log(logs)

  useEffect(() => {
    if (selectedOrder) {
      statusForm.setFieldsValue({
        order_status: selectedOrder.order_status || "",
        order_notes: selectedOrder.order_notes || "",
      });
      fetchLogs();
    }
  }, [selectedOrder, statusForm]);

  const fetchLogs = async () => {
    if (!selectedOrder || !selectedOrder.id) return;
    try {
      setLogsLoading(true);
      // Using content_type ID 91 for online_order as verified in backend
      const result = await getlog(1, 1000, 91, selectedOrder.id);
      if (result && result.results) {
        setLogs(result.results);
      }
    } catch (error) {
      console.error("Error fetching logs:", error);
    } finally {
      setLogsLoading(false);
    }
  };


  const handleSubmit = async (values) => {
    try {
      setSubmitting(true);
      await onUpdate(values);
      fetchLogs(); // Refresh logs after update
    } finally {
      setSubmitting(false);
    }
  };


  const orderStatusOptions = [
    { value: "Processing", color: "blue" },
    { value: "Already Called", color: "cyan" },
    { value: "Call Not Picked", color: "orange" },
    { value: "Waiting", color: "gold" },
    { value: "Confirmed", color: "green" },
    { value: "Cancelled", color: "red" },
    { value: "Others", color: "default" },
  ];

  return (
    <Card>
      <Form
        form={statusForm}
        layout="vertical"
        onFinish={handleSubmit}
        style={{ maxWidth: 600 }}
      >
        <Form.Item
          label="Order Status"
          name="order_status"
          rules={[{ required: true, message: "Please select order status" }]}
        >
          <Select placeholder="Select order status" size="large" loading={loading}>
            {orderStatusOptions.map((option) => (
              <Option key={option.value} value={option.value}>
                {option.value}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item label="Order Notes" name="order_notes">
          <Input.TextArea
            rows={4}
            placeholder="Add any notes or comments about this order..."
            maxLength={500}
            showCount
          />
        </Form.Item>

        <Form.Item>
          <Space>
            <Button
              type="primary"
              htmlType="submit"
              loading={submitting}
              icon={<CheckCircleOutlined />}
            >
              Update Status
            </Button>
            <Button onClick={() => statusForm.resetFields()} disabled={submitting}>
              Reset
            </Button>
          </Space>
        </Form.Item>
      </Form>

      {selectedOrder && (
        <>
          <Divider />
          <Descriptions title="Current Information" column={1} bordered size="small">
            <Descriptions.Item label="Order Status">
              {selectedOrder.order_status ? (
                <Tag color="blue">{selectedOrder.order_status}</Tag>
              ) : (
                <Text type="secondary">Not set</Text>
              )}
            </Descriptions.Item>
            <Descriptions.Item label="Order Notes">
              {selectedOrder.order_notes ? (
                <Input.TextArea
                  value={selectedOrder.order_notes}
                  readOnly
                  autoSize={{ minRows: 2, maxRows: 6 }}
                  style={{
                    border: "none",
                    resize: "none",
                  }}
                />
              ) : (
                <Text type="secondary">No notes</Text>
              )}
            </Descriptions.Item>
            <Descriptions.Item label="Last Updated">
              {selectedOrder.updated_at
                ? dateFormat(selectedOrder.updated_at, "dd-mm-yyyy hh:MM TT")
                : "N/A"}
            </Descriptions.Item>
          </Descriptions>
          <Divider />
          <div style={{ marginTop: 24 }}>
            <Typography.Title level={5} style={{ display: 'flex', alignItems: 'center', marginBottom: 16 }}>
              <HistoryOutlined style={{ marginRight: 8 }} /> Activity History
            </Typography.Title>

            {logsLoading ? (
              <Skeleton active paragraph={{ rows: 4 }} />
            ) : logs.length > 0 ? (
              <div style={{ maxHeight: 400, overflowY: 'auto', padding: '8px 16px 8px 8px' }}>
                <Timeline mode="left">
                  {logs.map((item, index) => {
                    const actionParts = item.action.split(/\(|\)/);
                    const event = (actionParts[0] && actionParts[0].trim().split(' ')[0]) || "Action";
                    const logDetails = {};

                    // Handle different log structures. Logs often have (id) (changes)
                    // We look for parts that contain " -> " to identify details
                    actionParts.forEach(part => {
                      if (part.includes(" -> ")) {
                        const detailList = part.split(", ");
                        detailList.forEach(detail => {
                          const parts = detail.split(": ");
                          if (parts.length > 1) {
                            const key = parts[0];
                            const values = parts[1].split(" -> ");
                            logDetails[key] = {
                              old: values[0],
                              new: values[1]
                            };
                          }
                        });
                      }
                    });

                    return (
                      <Timeline.Item key={index} color={event.toLowerCase().includes('create') ? "green" : "blue"}>
                        <div style={{ marginBottom: 4 }}>
                          <Text strong>{event}</Text> by <Text code>{item.created_by || "System"}</Text>
                        </div>
                        <div style={{ fontSize: '12px', color: '#8c8c8c', marginBottom: 8 }}>
                          {moment(item.timestamp).format("DD-MM-YYYY hh:mm A")}
                        </div>

                        {Object.keys(logDetails).length > 0 ? (
                          <div style={{ background: '#f5f5f5', padding: '8px', borderRadius: '4px', fontSize: '13px' }}>
                            <table style={{ width: '100%' }}>
                              <thead>
                                <tr style={{ borderBottom: '1px solid #d9d9d9' }}>
                                  <th style={{ textAlign: 'left', paddingBottom: 4 }}>Field</th>
                                  <th style={{ textAlign: 'left', paddingBottom: 4 }}>Old</th>
                                  <th style={{ textAlign: 'left', paddingBottom: 4 }}>New</th>
                                </tr>
                              </thead>
                              <tbody>
                                {Object.entries(logDetails).map(([key, val]) => (
                                  <tr key={key}>
                                    <td style={{ paddingTop: 4, fontWeight: 500 }}>{key}</td>
                                    <td style={{ paddingTop: 4 }}>
                                      <Text type="danger">{val.old}</Text>
                                    </td>
                                    <td style={{ paddingTop: 4 }}>
                                      <Text type="success">{val.new}</Text>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        ) : (
                          <div style={{ fontSize: '12px', color: '#8c8c8c', fontStyle: 'italic' }}>
                            {item.action}
                          </div>
                        )}
                      </Timeline.Item>
                    );
                  })}
                </Timeline>
              </div>
            ) : (
              <Text type="secondary">No activity logs found for this order.</Text>
            )}
          </div>
        </>
      )}
    </Card>
  );
};

export default connect(null, { getlog })(OrderStatusTab);